import React from 'react';
import { coreBenefitsData } from '../data/mock';
import { Check } from 'lucide-react';

const CoreBenefitsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
            {coreBenefitsData.title}
          </h2>
          <div className="grid gap-4 text-left">
            {coreBenefitsData.benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start gap-3 bg-gradient-to-r from-green-50 to-white p-6 rounded-lg border-l-4 border-green-500 shadow-sm hover:shadow-md transition-shadow"
              >
                <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-800 font-medium">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreBenefitsSection;
